import { Avatar, Box, Popover } from "@mui/material";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { useEffect } from "react";
import { useState } from "react";
import { apiService } from "../../constants/axiosInstance";

const IconPickerPopover = ({
  children,
  anchorOrigin,
  transformOrigin,
  iconProject,
  setIconProject,
  projectId,
  project,
  gantt = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [listIcon, setListIcon] = useState([]);
  async function doListDefaultIcon() {
    try {
      const config = {
        url: "/project/get-list-icon",
        method: "get",
      };
      const result = await apiService(config);
      setListIcon(result?.data?.icons ?? []);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    if (anchorEl !== null) {
      doListDefaultIcon();
    }
  }, [anchorEl]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box>
      <div onClick={handleClick}>{children}</div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: "bottom",
            horizontal: "left",
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical: "top",
            horizontal: "left",
          }
        }
      >
        <Box
          sx={{
            width: gantt ? "266px" : "246px",
            maxHeight: "400px",
            height: "auto",
            padding: "10px",
            flexFlow: "wrap",
            display: "flex",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#CCCCCC",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track": {
              boxShadow: "none",
            },
          }}
        >
          {listIcon.map((item) => (
            <Avatar
              alt="Logo"
              src={item?.url}
              sx={{
                "&:hover": {
                  background:
                    project?.group_project_color ?? "rgb(0, 120, 243)", // thay bằng màu group
                },
                width: gantt ? "30px" : "20px",
                height: gantt ? "30px" : "20px",
                ...(iconProject === item?.url
                  ? {
                      background:
                        project?.group_project_color ?? "rgb(0, 120, 243)", // thay bằng màu group
                    }
                  : {
                      background: "#EFF4F5",
                    }),
                borderRadius: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "5px",
                cursor: "pointer",
                padding: "5px",
              }}
              onClick={async () => {
                try {
                  const res = await apiService({
                    url: "/project/update-icon",
                    method: "put",
                    data: {
                      project_id: projectId,
                      icon: item?.value,
                    },
                  });
                  setIconProject(item?.url);
                  setAnchorEl(null);
                  SnackbarEmitter(
                    SNACKBAR_VARIANT.SUCCESS,
                    DEFAULT_MESSAGE.MUTATE.SUCCESS
                  );
                } catch (e) {
                  SnackbarEmitter(
                    SNACKBAR_VARIANT.ERROR,
                    DEFAULT_MESSAGE.MUTATE.ERROR
                  );
                }
              }}
            />
          ))}
        </Box>
      </Popover>
    </Box>
  );
};

export default IconPickerPopover;
